import {
    TAB_FEMALE,
    TAB_MALE,
} from '@client/config/constants';
import {
    getOpenCampaignsByType,
    getMyLounge,
    getReco,
} from '@client/services/api/mylounge-legacy';
import { cache } from './reducer';
import types from './types';

// updates the open campaigns, e.g. after filtering
// TODO Get rid of this
export const updateOpenCampaigns = (
    value = { campaigns: null, grid: null },
) => ({
    type: types.UPDATE_OPEN_CAMPAIGNS.SUCCESS,
    payload: value,
});

export const resetCache = () => ({
    type: types.RESET_CACHE,
});

export const updateReco = recommendation => ({
    type: types.FETCH_MY_RECO.SUCCESS,
    payload: recommendation,
});

export const updateMyLounge = (myLoungeData) => ({
    type: types.UPDATE_MYLOUNGE.SUCCESS,
    payload: myLoungeData,
});

// TODO Rewrite caching
// Regarding caching - think of redux-persist
// TODO Rewrite this in a way that doesn't modify action data as it should be immutable
// TODO Get rid of throwing exceptions out of this action creator
// TODO What is the difference between fetchMyLounge and fetchAllCampaignsForHeader ?? :)
export const fetchMyLounge = query => (dispatch, getState) => {
    const serverContext = getState().serverContext;

    dispatch({
        type: types.UPDATE_MYLOUNGE.REQUEST,
    });

    return getMyLounge(query, serverContext)
        .then(myLoungeData => {
            dispatch(updateMyLounge(myLoungeData));

            return Promise.resolve(myLoungeData);
        })
        .catch(error => {
            dispatch({
                type: types.UPDATE_MYLOUNGE.ERROR,
                payload: {
                    code: error.code || error.message || error,
                },
            });

            // TODO Get rid of this, that's insane stuff
            throw error;
        });
};

// TODO Rewrite caching
export const fetchOpenCampaigns = (filterTag, query) => (
    dispatch,
) => {
    dispatch({
        type: types.UPDATE_OPEN_CAMPAIGNS.REQUEST,
        payload: filterTag,
    });

    if (cache[filterTag]) {
        const { open, recommendation } = cache[filterTag];
        if (open) {
            dispatch(updateOpenCampaigns(open));
        }

        if (recommendation) {
            dispatch(updateReco(recommendation));
        }

        return Promise.resolve(cache[filterTag]);
    }

    return getOpenCampaignsByType(filterTag, query)
        .then(({ open, recommendation }) => {
            dispatch(updateOpenCampaigns(open));
            cache[filterTag] = {
                open,
                recommendation,
            };

            dispatch(updateReco(recommendation));

            return Promise.resolve(open);
        })
        .catch(error => {
            dispatch({
                type: types.UPDATE_OPEN_CAMPAIGNS.ERROR,
                payload: error,
            });
            Promise.reject(error);
        });
};

export const fetchMyReco = tab => dispatch => {
    // We only fetch reco if we choose a gender
    if (tab !== TAB_FEMALE && tab !== TAB_MALE) {
        return Promise.resolve(false);
    }

    dispatch({ type: types.FETCH_MY_RECO.REQUEST });

    return getReco(tab)
        .then(({ recommendation }) => {
            dispatch(updateReco(recommendation));

            return recommendation;
        })
        .catch(() => {
            dispatch({ type: types.FETCH_MY_RECO.ERROR });

            return false;
        });
};

// updates the active filter state
export const updateSelectedFilter = (value = 'all') => ({
    type: types.FILTER_CHANGED,
    payload: value,
});

// updates the slide index of the category slider, e.g. when using the arrows
export const updateCategorySlideIndex = (value = 0) => ({
    type: types.UPDATE_SLIDE_INDEX,
    payload: value,
});

export const toggleWelcomeBox = () => ({
    type: types.TOGGLE_WELCOME_BOX,
});

export const closeWelcomeBox = () => ({
    type: types.CLOSE_WELCOME_BOX,
});

export const updateImagesLoaded = value => ({
    type: types.UPDATE_IMAGES_LOADED,
    payload: value,
});
